import type { SVGProps } from 'react'

export const CameraIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      opacity='0.5'
      d='M9.778 21H14.222C17.343 21 18.904 21 20.025 20.265C20.5088 19.9482 20.9254 19.5391 21.251 19.061C22 17.961 22 16.428 22 13.364C22 10.3 22 8.76705 21.251 7.66705C20.9254 7.18904 20.5088 6.77991 20.025 6.46305C19.305 5.99005 18.403 5.82105 17.022 5.76105C16.363 5.76105 15.796 5.27105 15.667 4.63605C15.5684 4.17092 15.3123 3.75408 14.9418 3.456C14.5714 3.15791 14.1095 2.99686 13.634 3.00005H10.366C9.378 3.00005 8.527 3.68505 8.333 4.63605C8.204 5.27105 7.637 5.76105 6.978 5.76105C5.598 5.82105 4.696 5.99105 3.975 6.46305C3.49154 6.78001 3.07527 7.18914 2.75 7.66705C2 8.76705 2 10.299 2 13.364C2 16.429 2 17.96 2.749 19.061C3.073 19.537 3.489 19.946 3.975 20.265C5.096 21 6.657 21 9.778 21Z'
      fill='currentColor'
    />
    <path
      d='M17.5559 9.27201C17.4474 9.27109 17.3398 9.29154 17.2393 9.3322C17.1387 9.37286 17.0471 9.43293 16.9698 9.50898C16.8924 9.58503 16.8308 9.67558 16.7884 9.77544C16.7461 9.87531 16.7238 9.98254 16.7229 10.091C16.7229 10.543 17.0959 10.909 17.5559 10.909H18.6669C19.1269 10.909 19.5009 10.542 19.5009 10.091C19.5 9.98245 19.4777 9.87514 19.4353 9.77521C19.3928 9.67528 19.3311 9.58469 19.2537 9.50863C19.1762 9.43256 19.0845 9.37251 18.9838 9.33191C18.8832 9.29131 18.7755 9.27096 18.6669 9.27201H17.5559Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 9.27197C9.69998 9.27197 7.83398 11.104 7.83398 13.363C7.83398 15.622 9.69898 17.454 12.001 17.454C14.301 17.454 16.167 15.623 16.167 13.364C16.167 11.105 14.302 9.27197 12.001 9.27197M12.001 10.909C10.621 10.909 9.50098 12.008 9.50098 13.363C9.50098 14.718 10.621 15.818 12.001 15.818C13.382 15.818 14.501 14.719 14.501 13.363C14.501 12.008 13.382 10.909 12.001 10.909Z'
      fill='currentColor'
    />
  </svg>
)
